/** Plain-language Auto reasons. Never include prices. */

export function autoModelReasonLine(reasonCode?: string | null): string | null {
  if (reasonCode === 'budget_step_down') {
    return 'Auto used a lower-cost recommended model because the token budget is nearly used.';
  }
  if (reasonCode === 'budget_clamp') {
    return 'Auto kept the preferred model and limited the reply so it stays inside the token budget.';
  }
  return null;
}

export function autoReasonFromEventData(
  data?: Record<string, unknown> | null,
): string | null {
  if (!data) return null;
  const raw = data.model_selection || data.modelSelection;
  if (!raw || typeof raw !== 'object') return null;
  const selection = raw as { reason_code?: string; reasonCode?: string };
  const code = selection.reason_code || selection.reasonCode;
  return autoModelReasonLine(code);
}
